import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {StandService} from "../../../services/basic/airport/stand.service";
import {GateService} from "../../../services/basic/airport/gate.service";

@Component({
  selector: 'pi-location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.css']
})
export class LocationPickerComponent implements OnInit, OnChanges {
  @Input() selectMode: 'default' | 'multiple' = 'default';
  @Input() selectedLocationType: string;
  @Output() selectedLocationTypeChange = new EventEmitter<any>();
  @Input() ngModel: any;
  @Output() ngModelChange = new EventEmitter<any>();
  @Output() labelMapChange = new EventEmitter<any>();
  dataList: any = [];
  result;
  showSelect = false;
  labelMap: any;

  constructor(
    private standService: StandService,
    private gateService: GateService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.selectedLocationType) {
      this.showSelect = true;
    } else {
      this.showSelect = false;
    }
    this.loadData();
  }

  async loadData() {
    if (this.selectedLocationType === 'GATE') {
      this.dataList = await this.gateService.cachedFullData.toPromise();
    } else if(this.selectedLocationType === 'STAND') {
      this.dataList = await this.standService.cachedFullData.toPromise();
    }
    this.labelMap = {};
    this.dataList.forEach(data => {
      this.labelMap[data.id] = data.displayName;
    });
    this.labelMapChange.emit(this.labelMap);
  }

  setLocationType($event) {
    this.showSelect = true;
    this.selectedLocationTypeChange.emit($event);
    this.loadData();
  }


  showLocationSelector() {
    this.showSelect = false;
    this.ngModel = null;
  }

  onDataSet($event) {
    this.ngModelChange.emit($event);
  }
}
